// 鉴权初始化期间的占位组件，后续可替换为正式 UI。
export function AuthPendingShell() {
  return (
    <div style={{ padding: 16, fontSize: 14, color: '#888' }}>
      正在恢复登录状态...
    </div>
  )
}
